<script setup>
/*
    Render an image

    Components:
        primary: <v-img>, <img>

    Widget Properties:
        defaultValue
        url
            https://www.embedthis.com/images/pics/circuit-8.avif

    Component Args
        gradient: "to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"

    CSS Properties:
        border: 2px solid #ccc
        border-radius: 8px
        clip-path: circle(50% at 50% 50%);
        filter: filter: grayscale(100%) blur(2px);
        object-fit: fill, cover, contain, scale-down, none
        object-position: top right
        opacity: 0.5
        --w-gradient:to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)

    Examples
        card.background: 'green'
        clip-path: circle(50% at 50% 50%); // circle image
        opacity: 0.5
        filter: filter: grayscale(100%) blur(2px);
 */

import {reactive, ref} from 'vue'
import {getWidgetProps, pickItem} from '@/paks/vu-dash/BoardUtils'
import {State} from '@/paks/vu-app'

defineExpose({update})

const props = defineProps({widget: Object})

const page = reactive({
    args: {},
    data: {},
    item: {},
})

const primary = ref(null)

const DefaultStyles = {
    primary: {
        'object-fit': 'cover', //  fill, cover, contain, scale-down, none
    },
}

function update() {
    let widget = props.widget
    let outlook = widget.value ? widget.value[0]?.value : null
    Object.assign(page, getWidgetProps(widget, {primary}, {data: outlook, styles: DefaultStyles}))
    page.item = pickItem(widget.url, {inputs: State.context.inputs, value: page.data.primary})
}
</script>

<template>
    <v-img ref="primary" class="image-widget" v-bind="page.args" :src="page.item.value" />
</template>

<style lang="scss">
.image-widget {
    height: 100%;
    width: 100%;
    img {
        object-fit: inherit !important;
    }
}
</style>
